



import UMUM from         '../../../library/umum'
import FETCHING from  '../../../library/fetching'


export default {
  data() {
    return {

        form : {
            id : '',
            uraian : '',
            keterangan : '',

        },
        list_data : [],

        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
        UMUM : UMUM,
        FETCHING : FETCHING,
        cek_load_data :false,

        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,


    }
  },
  methods: {
    getData : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.office_m_jenisSurat + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              // console.log(res_data);
      });
    },

    addData : function() {
     
      fetch(this.$store.state.url.office_m_jenisSurat + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getData();
          console.log(res_data);
        });

    },

    editData : function(){

      fetch(this.$store.state.url.office_m_jenisSurat + "editData", {
          method: "POST",
          headers: {
              "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
           body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');          
          this.getData();
      });
    },

    removeData : function(idnya){
      fetch(this.$store.state.url.office_m_jenisSurat + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getData();
      });

    },

    selectData : function(data){
      this.form = {
        id : data.id,
        uraian : data.uraian,
        keterangan : data.keterangan,
      };
    },



    // =============================== TAMBAHAN ====================================
      Notify : function(message, positive, icon){
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position : 'top',
          timeout: 500,
        })
      },
      indexing : function(index){
          var idx = ((this.page_first-1)*this.page_limit)+index
          return idx
      },

      cari_data : function(){
          this.page_first = 1;
          this.getData();
      },
    // =============================== TAMBAHAN ====================================

  },

  mounted () {
    this.getData();
  },
}
